import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { hasModuleAccess } from '../lib/modules';

export const ProtectedRoute = ({ children, roles = [], moduleId, action = 'view' }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  if (roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (!hasModuleAccess(user, moduleId, action)) {
    if (moduleId === 'dashboard') {
      return <div className="p-6" role="status">Dashboard access is not enabled for your account. Contact your administrator or choose an available page from the menu.</div>;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};
